import { useEffect, useState } from "react";

/** Types phrases in and out with a blinking caret — same motion as the free-trial landing page. */
export const Typewriter = ({ phrases = [], typeSpeed = 65, deleteSpeed = 32, holdMs = 1900, className = "" }) => {
  const [index, setIndex] = useState(0);
  const [text, setText] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (phrases.length === 0) return;
    const current = phrases[index % phrases.length];

    if (!deleting && text === current) {
      const hold = setTimeout(() => setDeleting(true), holdMs);
      return () => clearTimeout(hold);
    }
    if (deleting && text === "") {
      setDeleting(false);
      setIndex((i) => (i + 1) % phrases.length);
      return;
    }
    const tick = setTimeout(() => {
      setText((t) => (deleting ? current.slice(0, t.length - 1) : current.slice(0, t.length + 1)));
    }, deleting ? deleteSpeed : typeSpeed);
    return () => clearTimeout(tick);
  }, [text, deleting, index, phrases, typeSpeed, deleteSpeed, holdMs]);

  return (
    <span className={className} data-testid="typewriter">
      {text}
      <span className="typewriter-caret" aria-hidden="true" />
    </span>
  );
};

export default Typewriter;
